<template>

  <rate-calendar-popup :title="item.event.name">

    <template v-slot:tools>
      <v-btn-group>
        <v-btn icon="$spotRate" @click="$emit('addException')" />
      </v-btn-group>
    </template>

    <p>
      {{ item.event.name }}
      <template v-if="canSeeIds">
        ({{ item.event.ID }})
      </template>
    </p>

    <p class="mt-2">
      <strong>Venue:</strong>
      {{ item.event.venueName }}
      <template v-if="canSeeIds">
        ({{ item.event.venueID }})
      </template>
    </p>

    <p class="mt-2">
      <strong>Time:</strong>
      {{ time }}
    </p>

    <table v-if="vlp" class="calendar-popup-table mt-2">
      <thead>
        <tr>
          <th scope="col">{{ $t('titles.default_cost') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="vlp.venueTiers.length">
          <tr v-for="venueTier in vlp.venueTiers">
            <td>
              {{ currencyFormatter.format(venueTier.tierPrice) }} up to
              {{ percentageFormatter.format(venueTier.tierInventoryPercentage) }}
            </td>
          </tr>
        </template>
      <template v-else>
        <tr>
          <td>
            {{ currencyFormatter.format(vlp.defaultPrice) }}
          </td>
        </tr>
      </template>
      </tbody>
    </table>

  </rate-calendar-popup>

</template>

<script setup lang="ts">

// components
import RateCalendarPopup from './RateCalendarPopup.vue'

// models
import { VenueLocationProduct } from '../../../../../models/VenueLocationProduct'

// misc
import type { EventEventItem } from '../types'
import PermissionsService from '../../../../../services/PermissionsService'
import { computed } from 'vue'
import PreferencesService from '../../../../../services/PreferencesService'
import { Temporal } from '@js-temporal/polyfill'
import { currencyFormatter, percentageFormatter } from '../../../../../utils/formatters'

interface Props {
  item: EventEventItem
}

const props = defineProps<Props>()
defineEmits(['addException'])

const canSeeIds = PermissionsService.can('seeids')

const time = computed<string>(() => {

  const locale = PreferencesService.preferences.locale
  let formattedStart = '?', formattedEnd = '?'

  try {
    const start = Temporal.PlainDateTime.from(props.item.event.eventStartLocal)
    formattedStart = start.toLocaleString(locale, {timeStyle: 'short'})
  } catch(e) {
    // fail silently
  }

  try {
    const end = Temporal.PlainDateTime.from(props.item.event.eventEndLocal)
    formattedEnd = end.toLocaleString(locale, {timeStyle: 'short'})
  } catch(e) {
    // fail silently
  }

  return `${formattedStart} – ${formattedEnd}`

})

const vlp = computed<null | VenueLocationProduct>(() => {
  const vlp = props.item.locationProduct.venueLocationProducts.find(vlp => vlp.venueID === props.item.event.venueID)
  return vlp ?? null
})

</script>
